// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCoat = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M18 20h4V6l-5-4H7L2 6v14h4v2h12zm-5-7.74V20h3v-7h2v5h2v-1h-1v-2h1V6.961l-2.808-2.247zM11 20H8v-7H6v5H4v-1h1v-2H4V6.961l2.809-2.247L11 12.26zm4.3-16H8.7L12 9.94z"
    />
  );
export default SvgIconCoat;
